<script lang="ts" setup>
import { CustomerFlow } from '../new-desktop/core/models';
import {
  CustomerOriginQueryParamValue,
  TripPlannerPage,
} from '../new-desktop/core/models/navigation';
import type { TripPlannerQueryParams } from '../new-desktop/core/models/navigation';
import {
  usePaxStore,
  useCustomerFlowStore,
  useRecipeStore,
  useRouterStore,
  useQueryParamsStore,
  useHotelAmenitiesStore,
  useUserStore,
} from '../new-desktop/core/stores';

import TripPlanner from './TripPlanner.vue';

const props = defineProps<TripPlannerQueryParams>();

const paxStore = usePaxStore();
const recipeStore = useRecipeStore();
const routerStore = useRouterStore();

const isCarTrip =
  routerStore.getCurrentTripPlannerView() === TripPlannerPage.CarTrip;

recipeStore.initializeProps({
  recipe: props.initialIngredients,
  preferredDay: props.initialSelectedDate,
  preferredMonth: props.initialSelectedMonth,
  itinerarySuggestionSortType: props.initialSuggestionSortType,
  returnTransport: props.returnTransport,
  metadata: props.metaData,
  searchForPackageRates: props.searchForPackageRates,
  isCarTrip,
});
paxStore.updatePax(props.initialPax);

const queryParamStore = useQueryParamsStore();
const customerFlowStore = useCustomerFlowStore();
const hotelAmenitiesStore = useHotelAmenitiesStore();
const userStore = useUserStore();

hotelAmenitiesStore.measureAmenities();
queryParamStore.setQueryParams(props);
userStore.fetchSemboUser();

if (
  props.customerOrigin === CustomerOriginQueryParamValue.MarketplaceFlightSearch
) {
  customerFlowStore.setCustomerFlow(CustomerFlow.FlightOnlyFromMarketplace);
}

if (
  props.customerOrigin === CustomerOriginQueryParamValue.MarketplaceHotelSearch
) {
  customerFlowStore.setCustomerFlow(CustomerFlow.HotelOnlyFromMarketplace);
}

if (props.customerOrigin === CustomerOriginQueryParamValue.InfiniteLoadReload) {
  customerFlowStore.setCustomerFlow(CustomerFlow.InfiniteLoadReload);
}

routerStore.setLandingRoute();
</script>

<template>
  <TripPlanner v-bind="props" />
</template>
